import { render, staticRenderFns } from "./BurgerMenu.vue?vue&type=template&id=6a901a5a&scoped=true"
import script from "./BurgerMenu.vue?vue&type=script&lang=ts"
export * from "./BurgerMenu.vue?vue&type=script&lang=ts"
import style0 from "./BurgerMenu.vue?vue&type=style&index=0&id=6a901a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a901a5a",
  null
  
)

export default component.exports